import { observer } from 'mobx-react-lite'
import React from 'react'
import Switch from '../../../../../../FormComponents/Switch'

export default observer(function FormulaItem({ title, value, formulaDescription, formulaImgSrc, blockDescription, imageClass, children, visibleField, visibleValue, setFieldValue }) {

  return (
    <div>
      <div className='flex justify-between items-center'>
        <p className={`font-bold my-4 ${visibleField && !visibleValue ? 'opacity-30' : ''}`}>{title}</p>
        {visibleField && <Switch name={visibleField} value={visibleValue} onChange={({ target: { checked }}) => setFieldValue(visibleField, checked, true)} eyeSwitch />}
      </div>

      <div className={`${visibleField && !visibleValue ? 'opacity-30' : ''}`}>
        <div className='mb-4'>{children}</div>
        <p className='font-bold text-2xl bg-gray-50 rounded w-fit p-4'>{value || '-'}</p>
        {formulaDescription && <div className='mt-4'>
          <p className='text-sm'><span className='font-bold'>Formula:</span> {formulaDescription}</p>
        </div>}
        <img className={imageClass} src={formulaImgSrc} alt="formula"/>
        <div className='my-4'>
          <p className='text-sm'><span className='font-bold'>Content Block Description:</span> {blockDescription}</p>
        </div>
        <div className="border-1 w-full border-gray-100" />
      </div>
    </div>
  )
})